export { default, default as DialogGetPhone } from './DialogGetPhone';
